import { useMutation } from "@apollo/client";
import {
  IonButton,
  IonButtons,
  IonCard,
  IonCardContent,
  IonContent,
  IonHeader,
  IonIcon,
  IonInput,
  IonItem,
  IonLabel,
  IonList,
  IonPage,
  IonSpinner,
  IonTextarea,
  IonTitle,
  IonToolbar,
} from "@ionic/react";
import { SUGGESTION } from "graphql/mutations";
import { chevronBackOutline, paperPlaneOutline } from "ionicons/icons";
import { useState } from "react";
import { useHistory } from "react-router-dom";

const Suggestion = () => {
  const [message, setMessage] = useState({});
  const [showLoading, setShowLoading] = useState(false);
  const [disabled, setDisabled] = useState(true);
  const history = useHistory();

  const [insertSuggestion] = useMutation(SUGGESTION);

  const submitMessage = async () => {
    if (
      message.business_name === "" ||
      message.business_phone === "" ||
      message.business_address === "" ||
      message.description === ""
    )
      return alert(
        "Business name, phone, address and description are required."
      );

    setShowLoading(true);

    const payload = {
      variables: {
        object: message,
      },
    };
    const res = await insertSuggestion(payload);
    if (res?.data?.insert_suggestions_one) {
      setShowLoading(false);
      alert("Suggestion request sent. Thank you.");
      setMessage({});
    } else {
      setShowLoading(false);
      alert("An error occurred.");
    }
  };

  const onChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;

    setMessage((prevState) => {
      return { ...prevState, [name]: value };
    });
    setDisabled(
      !message.business_name ||
        !message.business_phone ||
        !message.business_address ||
        !message.description
    );
  };

  return (
    <IonPage>
      <IonHeader className="ion-no-border">
        <IonToolbar className="background-color">
          <IonButtons slot="start">
            <IonButton onClick={() => history.goBack()}>
              <IonIcon icon={chevronBackOutline} color="dark" size="large" />
            </IonButton>
          </IonButtons>
          <IonTitle>Suggest a Business</IonTitle>
          <IonButtons slot="end">
            <IonButton onClick={() => submitMessage()} disabled={disabled}>
              {showLoading ? (
                <IonSpinner name="crescent" />
              ) : (
                <IonIcon icon={paperPlaneOutline} color="dark" />
              )}
            </IonButton>
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <IonHeader collapse="condense">
          <IonToolbar>
            <IonTitle size="large">Suggest a Business</IonTitle>
          </IonToolbar>
        </IonHeader>
        <IonCard>
          <IonCardContent>
            <h2>
              <strong>Let us do the heavy lifting.</strong>
            </h2>
            <p>
              Suggest a business who has expressed interest and we will take
              care of the rest.
            </p>
          </IonCardContent>
        </IonCard>
        <IonList>
          <IonItem>
            <IonLabel position="stacked">Business Name *</IonLabel>
            <IonInput
              type="text"
              name="business_name"
              placeholder="Enter name"
              value={message.business_name}
              onIonChange={(e) => onChange(e)}
              required
            ></IonInput>
          </IonItem>
          <IonItem>
            <IonLabel position="stacked">Business Phone *</IonLabel>
            <IonInput
              type="tel"
              name="business_phone"
              placeholder="Enter phone"
              value={message.business_phone}
              onIonChange={(e) => onChange(e)}
              required
            ></IonInput>
          </IonItem>
          <IonItem>
            <IonLabel position="stacked">Business Address *</IonLabel>
            <IonInput
              type="text"
              name="business_address"
              placeholder="Enter address"
              value={message.business_address}
              onIonChange={(e) => onChange(e)}
              required
            ></IonInput>
          </IonItem>
          <IonItem>
            <IonLabel position="stacked">Business Email (optional)</IonLabel>
            <IonInput
              type="email"
              name="business_email"
              placeholder="Enter email"
              value={message.business_email}
              onIonBlur={(e) => onChange(e)}
              required
            ></IonInput>
          </IonItem>
          <IonItem>
            <IonLabel position="stacked">More Info</IonLabel>
            <IonTextarea
              name="description"
              placeholder="How interested is the business owner or management in Oshi?"
              value={message.description}
              rows={15}
              onIonChange={(e) => onChange(e)}
              required
            ></IonTextarea>
          </IonItem>
        </IonList>
      </IonContent>
    </IonPage>
  );
};

export default Suggestion;
